function trimTrailingSlash(value) {
  return typeof value === 'string' ? value.replace(/\/+$/, '') : ''
}

function resolveHostedApiOrigin(hostname) {
  if (hostname === 'payment-result.ultracafe.ru') {
    return 'https://api.ultracafe.ru'
  }

  if (hostname === 'payres.zrok.ultracafe.ru') {
    return 'https://apiuc.zrok.ultracafe.ru'
  }

  return ''
}

export function getPaymentResultApiBase() {
  const configuredBase = trimTrailingSlash(import.meta.env.VITE_API_BASE_URL || '')

  if (/^https?:\/\//i.test(configuredBase)) {
    return configuredBase
  }

  if (
    configuredBase === '' ||
    configuredBase.startsWith('/orders/api')
  ) {
    const hostedOrigin = resolveHostedApiOrigin(window.location.hostname)
    if (hostedOrigin) {
      return hostedOrigin
    }
  }

  return configuredBase
}

export function buildPaymentResultApiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const apiBase = getPaymentResultApiBase()
  const apiPathPrefix = '/orders/api'

  if (apiBase.endsWith(apiPathPrefix) && normalizedPath.startsWith(`${apiPathPrefix}/`)) {
    return `${apiBase}${normalizedPath.slice(apiPathPrefix.length)}`
  }

  return apiBase ? `${apiBase}${normalizedPath}` : normalizedPath
}
